import { useUIStore } from '@/stores/ui'
import { useMediaQuery } from '@/hooks/useMediaQuery'

// Returns the px offset to shift a viewport-centered element into the content area.
// On desktop: half the sidebar width so the element appears centered in the content.
// On mobile: 0 (no sidebar).
export function useSidebarOffset(): number {
  const sidebarExpanded = useUIStore((s) => s.sidebarExpanded)
  const isDesktop = useMediaQuery('(min-width: 1024px)')
  if (!isDesktop) return 0
  return sidebarExpanded ? 104 : 28 // half of w-52 (208px) or w-14 (56px)
}
